import React from 'react'

export const ImgUI = ({style, routeImg}) => {
  return (
    <img className={style} src={routeImg}  />
  )
}
